<div class="container-fluid d-flex justify-content-center align-items-center vh-100" style="background: #f4f4f4;">
  <div class="col-12 col-sm-8 col-md-6 col-lg-4" style="max-width: 500px;">
    <form class="card p-5 shadow-lg" [formGroup]="loginForm" (ngSubmit)="onLogin()">
      <div class="card-body">
        <h5 class="card-title text-center pb-4" style="text-transform: uppercase; color: #3f51b5; font-weight: 600;">Login</h5>

        <mat-form-field appearance="outline" class="w-100 mb-3">
          <mat-label>Email</mat-label>
          <input matInput id="clientId" type="text" formControlName="clientId" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100 mb-3">
          <mat-label>Senha</mat-label>
          <input matInput id="secret" type="password" formControlName="secret" required>
        </mat-form-field>

        <div class="text-center">
          <button mat-raised-button color="primary" class="w-100" type="submit" [disabled]="!loginForm.valid" style="text-transform: uppercase;">Entrar</button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="loader" *ngIf="showLoader">
  <div class="content-loader">
    <mat-spinner></mat-spinner>
  </div>
</div>
